import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Cushion, Grid, Hide, Rectangle, Typography } from '@pitchero/react-ui';
import ProfileLink from './profile-link';

const ScorecardBatsman = ({
  avatar,
  ballsFaced,
  dismissal,
  gridColumns,
  gridResponsive,
  hasBallsFacedStats,
  isPairs,
  name,
  netScore,
  runs,
  fours,
  sixes,
  strikeRate,
  timesOut,
  teamId,
  id,
}) => (
  <Rectangle fill="white" borderBottom="thinLightGrey">
    <Cushion
      all="small"
      left="medium"
      responsive={[{ maxWidth: 'tab', props: { left: 'small' } }]}
      component="div"
    >
      <Grid columns={gridColumns} responsive={gridResponsive} alignItems="center">
        <Grid
          columns="48px 1fr"
          responsive={[{ maxWidth: 'tab', props: { display: 'block' } }]}
          columnGap="medium"
          alignItems="center"
        >
          <Hide maxWidth="tab" component="div">
            <ProfileLink teamId={teamId} name={name} playerId={id}>
              <Avatar image={avatar} includeRetina alt={name} />
            </ProfileLink>
          </Hide>
          <div>
            <ProfileLink teamId={teamId} name={name} playerId={id}>
              <Typography preset="subtitle--small" color="black" component="div">
                {name}
              </Typography>
            </ProfileLink>
            <Typography preset="description" color="dustygrey">
              {dismissal}
            </Typography>
          </div>
        </Grid>
        <Typography
          preset={isPairs ? 'body--small' : 'subtitle--small'}
          color={isPairs ? 'dustygrey' : 'black'}
          component="div"
          align="center"
        >
          {runs}
        </Typography>
        {hasBallsFacedStats && (
          <Typography preset="body--small" color="dustygrey" component="div" align="center">
            {ballsFaced}
          </Typography>
        )}
        <Hide maxWidth={hasBallsFacedStats ? 'palm' : 0}>
          <Typography preset="body--small" color="dustygrey" component="div" align="center">
            {fours}
          </Typography>
        </Hide>
        <Hide maxWidth={hasBallsFacedStats ? 'palm' : 0}>
          <Typography preset="body--small" color="dustygrey" component="div" align="center">
            {sixes}
          </Typography>
        </Hide>
        {hasBallsFacedStats && !isPairs && (
          <Typography preset="body--small" color="dustygrey" component="div" align="center">
            {strikeRate}
          </Typography>
        )}
        {isPairs && (
          <Typography preset="body--small" color="dustygrey" component="div" align="center">
            {timesOut}
          </Typography>
        )}
        {isPairs && (
          <Typography preset="subtitle--small" color="black" component="div" align="center">
            {netScore}
          </Typography>
        )}
      </Grid>
    </Cushion>
  </Rectangle>
);

ScorecardBatsman.defaultProps = {
  ballsFaced: null,
  runs: null,
  fours: null,
  netScore: null,
  sixes: null,
  strikeRate: null,
  timesOut: null,
  teamId: null,
};

ScorecardBatsman.propTypes = {
  avatar: PropTypes.string.isRequired,
  ballsFaced: PropTypes.number,
  dismissal: PropTypes.string.isRequired,
  gridColumns: PropTypes.string.isRequired,
  gridResponsive: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  hasBallsFacedStats: PropTypes.bool.isRequired,
  isPairs: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  netScore: PropTypes.number,
  runs: PropTypes.number,
  fours: PropTypes.number,
  sixes: PropTypes.number,
  timesOut: PropTypes.number,
  strikeRate: PropTypes.string,
  teamId: PropTypes.number,
  id: PropTypes.string.isRequired,
};

export default ScorecardBatsman;
